import { queryOptions } from '@tanstack/react-query'
import { Pagination } from '@thinknimble/tn-models'
import { organizationApi, userApi } from './api'

/**
 * @link https://tkdodo.eu/blog/the-query-options-api?ck_subscriber_id=1819338276
 * Create query factories for a more type safe solution of the queries across the app. This way whichever invalidation that has to happen in the resource can be done with `queryClient.invalidateQueries(userQueries.all())` or any other of the query factory's functions.
 * In this case we do have a very simple example for the user query but depending on the resource we may want to add more query factories
 */

export const userQueries = {
  all: () => ['users'],
  retrieve: (id: string) =>
    queryOptions({
      queryKey: [...userQueries.all(), id],
      queryFn: () => userApi.retrieve(id),
      enabled: Boolean(id),
    }),
  list: () =>
    queryOptions({
      queryKey: userQueries.all(),
      queryFn: () => userApi.list(),
      enabled: true,
    }),
}

export const organizationQueries = {
  all: () => ['organizations'],
  retrieve: (id: string) =>
    queryOptions({
      queryKey: [...organizationQueries.all(), id],
      queryFn: () => organizationApi.retrieve(id),
      enabled: Boolean(id),
    }),
  list: ({
    filters,
    pagination,
    paginationCallback,
  }: {
    filters?: Partial<{ search: string; hasProperties: string }>
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  } = {}) => {
    return queryOptions({
      queryKey: [...organizationQueries.all(), { filters, pagination }],
      queryFn: async () => {
        const res = await organizationApi.list({ filters, pagination })
        const serverPagination = new Pagination({ ...res, totalCount: res.count })
        paginationCallback?.(serverPagination)
        return res
      },
      enabled: true,
    })
  },
}
